import { Menu } from "antd";
import styled from "styled-components";

import { ThemeProp } from "styles/theme";
import { datastoresMenuFonts } from "styles/font-sizes";

export const StyledMenu = styled(Menu)`
  &.ant-menu {
    border-right: none;
    background: ${({ theme }: ThemeProp) => theme.secondaryColor};

    .ant-menu-title-content {
      margin-left: 5px;
      font-size: ${datastoresMenuFonts.datastoreTitle}px;
      display: flex;
      align-items: center;
    }

    &,
    .ant-menu-submenu-selected {
      color: ${({ theme }: ThemeProp) => theme.textInDark};
    }

    .ant-menu-sub.ant-menu-inline {
      background: ${({ theme }: ThemeProp) => theme.secondaryColor};
      color: ${({ theme }: ThemeProp) => theme.textInDark};
      padding-left: 20px;
    }

    .ant-menu-submenu-title[style] {
      .ant-menu-submenu-arrow,
      &:hover .ant-menu-submenu-arrow {
        color: white;
      }

      .ant-menu-submenu-arrow {
        right: 5px;
      }

      :hover {
        border-radius: 8px;
        border-left: 2px solid white;
        background: ${({ theme }: ThemeProp) => `${theme.secondaryColor}70`};
        opacity: 0.7;
        color: white;
      }
    }

    .ant-menu-submenu-arrow {
      color: white;
    }

    .ant-menu-item[style] {
      color: ${({ theme }: ThemeProp) => theme.textInDark};
      background: transparent;
      width: max-content;
      max-width: 100%;
      padding: 0 7px !important;
      border-radius: 8px;
      height: 30px;
      display: flex;
      align-items: center;

      &,
      * {
        transition: none !important;
      }

      :hover,
      &.ant-menu-item-selected {
        background: ${({ theme }: ThemeProp) => theme.emptyBackground};
        color: ${({ theme }: ThemeProp) => theme.textInLight};

        * {
          color: inherit;
        }
      }
    }

    .ant-menu-item-selected::after {
      display: none;
    }

    .ant-menu-item-selected::before {
      content: " ";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      border-left: 5px solid ${({ theme }: ThemeProp) => theme.highlight};
    }
  }
`;
